<template>
  <div>
    <el-form
      @submit.native.prevent
      class="cml-search-form"
      ref="listForm"
      :model="listForm"
      :inline="true"
      label-width="100px"
      size="mini"
    >
      <el-row>
        <el-form-item label="产品名称" prop="productName">
          <el-input
            v-model.trim="listForm.productName"
            clearable
            @keyup.13.native="onSearch"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button type="primary" @click="onReset">清空</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <div class="cml-button-group cml-tab-button-group">
      <el-tabs type="card" v-model="selectTab" @tab-click="tabChange">
        <el-tab-pane type="text" name="Tab1" label="草稿箱"></el-tab-pane>
        <el-tab-pane type="text" name="Tab2" label="待审核"></el-tab-pane>
        <el-tab-pane type="text" name="Tab3" label="已驳回"></el-tab-pane>
      </el-tabs>
      <div v-if="selectTab === 'Tab1'" class="cml-tabs-btn-group">
        <el-button
          size="mini"
          v-hasPermission="'indirect-manage/product-list-create'"
          @click="newProductBtn"
        >发布新产品</el-button>
        <el-button
          size="mini"
          :loading="batchSubmitLoading"
          v-hasPermission="'indirect-manage/product-list-submit'"
          @click="batchSubmitBtn"
        >批量提交审核</el-button>
        <BatchImport
          ref="Import"
          @importSuccess="onSearch"
        />
      </div>
    </div>
    <div v-show="selectTab === 'Tab1'">
      <CommonTable
        ref="CommonTableRefTab1"
        :loading="tableLoading"
        :tableHead="tableHeadTab1"
        :tableData="tableDataTab1"
        :tableParam="tableParamTab1"
        @page-size-change="pageSizeChange"
        @select-change="selectChange"
        @sort-change="sortChange"
      >
        <template #idSlot="{ row }">
          <div class="cml-sample-info">
            <el-image
              v-if="row.mainImage"
              style="width: 50px; height: 50px; margin-right: 5px;"
              :src="row.mainImage + $ImgQuality30"
              :preview-src-list="[row.mainImage + $ImgPreviewQuality]"
              :fit="fit"
            >
              <div slot="placeholder" class="sample-image-slot">
                加载中
              </div>
            </el-image>
            <div>
              <p>产品ID：{{ row.productId }} </p>
              <span @click="toDetail(row)">{{ row.productName }}</span>
            </div>
          </div>
        </template>
        <template #operationSlot="{ row }">
          <el-button
            @click="editBtn(row)"
            type="text"
            v-hasPermission="'indirect-manage/product-list-update'"
          >修改</el-button>
          <el-button
            @click="operateBtn('pdLibraryDelete', '删除', row)"
            type="text"
            v-hasPermission="'indirect-manage/product-list-delete'"
          >删除</el-button>
        </template>
      </CommonTable>
    </div>

    <div v-show="selectTab === 'Tab2'">
      <CommonTable
        ref="CommonTableRefTab2"
        :loading="tableLoading"
        :tableHead="tableHeadTab2"
        :tableData="tableDataTab2"
        :tableParam="tableParamTab2"
        @page-size-change="pageSizeChange"
        @select-change="selectChange"
        @sort-change="sortChange"
      >
        <template #idSlot="{ row }">
          <div class="cml-sample-info">
            <el-image
              v-if="row.mainImage"
              style="width: 50px; height: 50px; margin-right: 5px;"
              :src="row.mainImage + $ImgQuality30"
              :preview-src-list="[row.mainImage + $ImgPreviewQuality]"
              :fit="fit"
            >
              <div slot="placeholder" class="sample-image-slot">
                加载中
              </div>
            </el-image>
            <div>
              <p>产品ID：{{ row.productId }} </p>
              <span @click="toDetail(row)">{{ row.productName }}</span>
            </div>
          </div>
        </template>
        <template #operationSlot="{ row }">
          <el-button
            @click="recallBtn(row.id)"
            v-hasPermission="'indirect-manage/product-list-recall'"
            type="text"
          >撤回</el-button>
        </template>
      </CommonTable>
    </div>

    <div v-show="selectTab === 'Tab3'">
      <CommonTable
        ref="CommonTableRefTab3"
        :loading="tableLoading"
        :tableHead="tableHeadTab3"
        :tableData="tableDataTab3"
        :tableParam="tableParamTab3"
        @page-size-change="pageSizeChange"
        @select-change="selectChange"
        @sort-change="sortChange"
      >
        <template #idSlot="{ row }">
          <div class="cml-sample-info">
            <el-image
              v-if="row.mainImage"
              style="width: 50px; height: 50px; margin-right: 5px;"
              :src="row.mainImage + $ImgQuality30"
              :preview-src-list="[row.mainImage + $ImgPreviewQuality]"
              :fit="fit"
            >
              <div slot="placeholder" class="sample-image-slot">
                加载中
              </div>
            </el-image>
            <div>
              <p>产品ID：{{ row.productId }} </p>
              <span @click="toDetail(row)">{{ row.productName }}</span>
            </div>
          </div>
        </template>
        <template #statusSlot="{ row }">
          <div class="cml-sample-info">
            <div>
              <p style="cursor: auto">{{ row.statusName }}</p>
              <el-popover
                v-if="row.status === 'REJECT'"
                placement="top"
                width="300"
                trigger="click"
                :content="'驳回意见：' + row.auditOpinion"
              >
                <el-button type="text" slot="reference">查看原因</el-button>
              </el-popover>
            </div>
          </div>
        </template>
        <template #operationSlot="{ row }">
          <el-button
            @click="editBtn(row)"
            type="text"
            v-hasPermission="'indirect-manage/product-list-update'"
            >修改</el-button
          >
          <el-button
            @click="operateBtn('pdLibraryDelete', '删除', row)"
            type="text"
            v-hasPermission="'indirect-manage/product-list-delete'"
          >删除</el-button>
        </template>
      </CommonTable>
    </div>
    <!-- 批量操作后的弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="resultDialogVisible"
    >
      <ResultDialog
        :showText="showText"
        :dialogResult="dialogResult"
        :tableDataField="'failResultList'"
        :showNameCol="true"
      />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="resultDialogClose" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ResultDialog from '@/components/ResultDialog';
import CommonTable from '@/components/CommonTable';
import sampleMixin from '@/mixins/sampleMixin';
import BatchImport from './BatchImport.vue';

export default {
  components: {
    ResultDialog,
    CommonTable,
    BatchImport
  },
  mixins: [sampleMixin],
  props: {},
  data() {
    return {
      importTemplateList: [],
      listForm: {
        productName: '',
      },
      selectTab: 'Tab1',
      tableLoading: false,
      status: { Tab1: 'EDIT', Tab2: 'PENDING', Tab3: 'REJECT' },
      tableParamTab1: {
        pageNo: 1,
        pageSize: 20
      },
      tableParamTab2: {
        pageNo: 1,
        pageSize: 20
      },
      tableParamTab3: {
        pageNo: 1,
        pageSize: 20
      },
      tableHeadTab1: [
        { label: '产品信息', prop: 'id', slotColumn: true, slotName: 'idSlot' },
        { label: '状态', prop: 'statusName', width: 150 },
        { label: '类型', prop: 'secondCategoryName', width: 150 },
        { label: '编辑账号', prop: 'updateByName', width: 150 },
        { label: '修改时间', prop: 'updateDate', width: 150, sortable: true },
        {
          label: '操作',
          prop: 'operation',
          slotColumn: true,
          slotName: 'operationSlot',
          width: 150,
        },
      ],
      tableHeadTab2: [
        { label: '产品信息', prop: 'id', slotColumn: true, slotName: 'idSlot' },
        { label: '状态', prop: 'statusName', width: 150 },
        { label: '编辑账号', prop: 'updateByName', width: 150 },
        { label: '提交时间', prop: 'submitDate', width: 150, sortable: true },
        {
          label: '操作',
          prop: 'operation',
          slotColumn: true,
          slotName: 'operationSlot',
          width: 150,
        },
      ],
      tableHeadTab3: [
        { label: '产品信息', prop: 'id', slotColumn: true, slotName: 'idSlot' },
        {
          label: '状态',
          prop: 'statusName',
          width: 150,
          slotColumn: true,
          slotName: 'statusSlot',
        },
        { label: '编辑账号', prop: 'updateByName', width: 150 },
        { label: '审核时间', prop: 'auditDate', width: 150, sortable: true },
        {
          label: '操作',
          prop: 'operation',
          slotColumn: true,
          slotName: 'operationSlot',
          width: 150,
        },
      ],
      tableDataTab1: {},
      tableDataTab2: {},
      tableDataTab3: {},
      selectionTab1: [],
      selectionTab2: [],
      selectionTab3: [],
      onLoading: false,
      offLoading: false,
      permissionData: [],
      dialogResult: {},
      resultDialogVisible: false,
      showText: true,
      fit: 'contain',
      batchSubmitLoading: false
    };
  },
  computed: {
    btnDisabled() {
      return this[`selection${this.selectTab}`].length < 1;
    },
    selectData() {
      return this[`selection${this.selectTab}`].length !== 1;
    }
  },
  watch: {
    selectTab() {
      this.getList();
    },
  },
  mounted() {
    this.$refs.CommonTableRefTab1.changeHeight(120);
    this.$refs.CommonTableRefTab2.changeHeight(120);
    this.$refs.CommonTableRefTab3.changeHeight(120);
    this.getList();
    this.getImportTemplateList();
  },
  methods: {
    getImportTemplateList () {
      this.$http.pdLibrary.getPdImportTemplateUrl().then(result => {
        this.importTemplateList = result.data;
      }).catch(err => {
        this.$message.error(err.msg);
      });
    },
    selectChange (arr) {
      this[`selection${this.selectTab}`] = arr;
    },
    batchSubmitBtn () {
      const ids = this[`selection${this.selectTab}`].map(item=>item.id)
      if(ids.length === 0) {
        this.$message.error('请勾选产品信息');
        return false;
      }
      this.$confirm(`确定批量提交吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.batchSubmitLoading = true;
        this.$http.pdLibrary.pdLibraryBatchSubmit(ids).then(result => {
          this.$message.success(result.msg);
          this.onSearch();
        }).catch(err => {
          this.$message.error(err.msg);
        }).finally(() => {
          this.batchSubmitLoading = false;
        });
      });
    },
    toDetail (row) {
      this.$store.dispatch('tagsView/jumpAndClosePage', {
        open: {
          name: row.productName,
          href: `/indirect-manage/indirect-details-page?id=${row.productId}&firstCategory=${row.firstCategory}`,
          isURLSearchParams: true
        },
      });
      this.$router.push({
        name: 'indirect-manage/indirect-details-page',
        query: {
          id: row.productId,
          firstCategory: row.firstCategory || ''
        },
      });
    },
    newProductBtn () {
      this.$store.dispatch('tagsView/changeHeaderMenusList', {
        name: '新产品',
        href: '/indirect-manage/publish-new-product',
      });
      this.$router.push({
        name: 'indirect-manage/publish-new-product',
        query: {
          status: 'create',
          statusName: '新增'
        }
      });
    },
    onSearch() {
      this[`tableParam${this.selectTab}`].pageNo = 1;
      this.getList();
    },
    getList() {
      const params = {
        ...this[`tableParam${this.selectTab}`],
        data: this.listForm,
      };
      params.data.statusList = [this.status[this.selectTab]];
      this.tableLoading = true;
      this.$http.pdLibrary.pdLibraryListPage(params).then(result => {
          this[`tableData${this.selectTab}`] = result.data;
          this[`selection${this.selectTab}`] = [];
          this.$refs[`CommonTableRef${this.selectTab}`].clearCheckboxRow();
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    editBtn(row) {
      this.$refs[`CommonTableRef${this.selectTab}`].$refs.vxeTable.closeTooltip()
      this.$store.dispatch('tagsView/changeHeaderMenusList', {
        name: '新产品',
        href: '/indirect-manage/publish-new-product',
      });
      this.$router.push({
        name: 'indirect-manage/publish-new-product',
        query: {
          id: row.id,
          status: 'update',
          statusName: '修改',
          productId: row.productId,
          type: row.firstCategory
        }
      });
    },
    recallBtn (id) {
      this.$confirm(`确定撤回样品?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.pdLibrary.pdLibraryBatchRecall([id]).then(result => {
          this.$message.success(result.msg);
          this.onSearch();
        }).catch(err => {
          this.$message.error(err.msg);
        }).finally(() => {
          this.tableLoading = false;
        });
      });
    },
    operateBtn(url, title, row) {
      this.$confirm(`确定${title}样品?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.pdLibrary[url]({
          firstCategory: row.firstCategory,
          productId: row.productId
        }).then(result => {
          this.$message.success(result.msg);
          this.onSearch();
        }).catch(err => {
          this.$message.error(err.msg);
        }).finally(() => {
          this.tableLoading = false;
        });
      });
    },
    resultDialogClose() {
      this.resultDialogVisible = false;
      this.getList();
    },
    copySample(row) {
      this.$refs[`CommonTableRef${this.selectTab}`].$refs.vxeTable.closeTooltip();
      this.jumpUrl(row, 'copy', 'reload');
    }
  },
};
</script>

<style lang="less" scoped>
.download-file {
  display: inline-block;
  & > a {
    margin: 0 5px;
  }
}
.el-link {
  display: block;
  margin: 15px;
}
.setImg {
  position: absolute;
  width: 50px;
  height: 50px;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
  background: #fff;
  box-sizing: border-box;
  border: 1px solid #ccc;
  padding: 0;
  &::after {
    content: '产品主图';
    position: absolute;
    left: 0;
    top: 0;
    height: 16px;
    line-height: 16px;
    text-align: center;
    background: #555;
    color: #fff;
  }
  &::before {
    content: '设置';
    position: absolute;
    left: 12px;
    top: 23px;
    height: 16px;
    line-height: 16px;
    color: #AB0033;
  }
}
</style>
